<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon>chat</mat-icon>
				<span>Direktchat</span>
			</div>

			@if( bFirstLoading || bCreatingChat ) {
				<mat-spinner diameter=30 />
			}

		</div>
		
		<div class="directChatPanel">
		
			<div class="contactColumn">
		
				<div class="contactsLabel">Kontakte</div>

				@if( !bFirstLoading ) {

					<div class="searchDiv">
			
						<span class="material-icons searchDiv__icon">search</span>
			
						<input
							type="text"
							placeholder="Kontakt suchen"
							class="searchInput"
							[(ngModel)]="strContactFilter"
							(input)="contactFilter($event)"
						>
			
					</div>
					
					<div class="contactPanel">

						@if( !contactsFiltered.length ) {
							<div class="noElements">
								Kein Kontakt wurde gefunden
							</div>
						}
						@else {

						<table
							class="contactTable"
							matSort 
							(matSortChange)="sortData($event)"
							[matSortDisableClear]="true"
							[matSortActive]="'contactName'"
							[matSortDirection]="'asc'"
						>

							<thead>
								<tr>
									<th></th>
									<th mat-sort-header="contactName">Name</th>
									<th mat-sort-header="contactMiglied">Verein</th>
								</tr>
							</thead>
							
							<tbody>

								@for( contact of contactsFiltered; track contact.ebeId ) {
							
								<tr (click)="clickContact(contact.ebeId)">

									<td class="contactTable__avatarCell">
										<img
											class="contactAvatarImg"
											[src]="contactAvatarUrls[contact.ebeId] || defaultAvatar"
											[attr.alt]="contactNames[contact.ebeId] || contact.ebeId"
											loading="lazy"
										/>
									</td>
									<td class="txtWrap">
										{{ contactNames[ contact.ebeId ] }}
									</td>
									<td class="txtWrap">
										{{ contact.mitgliedsname || '' }}
									</td>

										</tr>

									}

								</tbody>
	
							</table>

						}

			
					</div>

				}
				@else {
					<mat-spinner style="align-self: center" />
				}
		
			</div>

			<button
				mat-raised-button
				[disabled]="bFirstLoading || bCreatingChat"
				[routerLink]="['..']"
			>
				Abbrechen
			</button>

			@if( bSavingError ) {
				<div class="saveError">
					<span class="material-icons">error</span>
					<span>Beim Starten des Chats ist ein Fehler aufgetreten</span>
				</div>
			}
			
		</div>


	</div>

</div>

